// Copyright 2025, Imprivata, Inc.  All rights reserved.

import AdvancedSettings from '../advancedSettings/AdvancedSettings';
import Appearance from '../appearance/Appearance';
import Applications from '../applications/Applications';
import IdentityUsers from '../identityUsers/IdentityUsers';

// Integrations
import AipIntegration from '../integrations/AipIntegration';
import EamIntegration from '../integrations/EamIntegration';
import SamlIdp from '../integrations/SamlIdp';
import VpamIntegration from '../integrations/VpamIntegration';

import PasswordPolicy from '../passwordPolicy/PasswordPolicy';
import EpcsActivityReport from '../reports/EpcsActivityReport';
import LoginActivityReport from '../reports/LoginActivityReport';
import Security from '../security/Security';
// Users
import Users from '../users/Users';

export const SETTINGS_TAB_KEYS = {
  users: 'users',
  identityUsers: 'identity-users',
  applications: 'applications',
  samlIdp: 'saml-idp',
  eamIntegration: 'eam-integration',
  vpamIntegration: 'vpam-integration',
  aipIntegration: 'aip-integration',
  security: 'security',
  passwordPolicy: 'password-policy',
  customize: 'customize',
  loginActivityReport: 'login-activity-report',
  epcsActivityReport: 'epcs-activity-report',
  advancedSettings: 'advanced-settings',
} as const;

export type SettingsTab = (typeof SETTINGS_TAB_KEYS)[keyof typeof SETTINGS_TAB_KEYS];

const TRANSLATION_ROOT = 'portal.settings.tabs-title';

export const SETTINGS_TABS: Array<{
  key: SettingsTab;
  titleKey: string;
  descriptionKey?: string;
  component: React.ComponentType;
}> = [
  {
    key: SETTINGS_TAB_KEYS.users,
    titleKey: `${TRANSLATION_ROOT}.entra-id-users`,
    component: Users,
  },
  {
    key: SETTINGS_TAB_KEYS.identityUsers,
    titleKey: `${TRANSLATION_ROOT}.identity-users`,
    component: IdentityUsers,
  },
  {
    key: SETTINGS_TAB_KEYS.applications,
    titleKey: `${TRANSLATION_ROOT}.applications`,
    component: Applications,
  },
  { key: SETTINGS_TAB_KEYS.samlIdp, titleKey: `${TRANSLATION_ROOT}.saml-idp`, component: SamlIdp },
  {
    key: SETTINGS_TAB_KEYS.eamIntegration,
    titleKey: `${TRANSLATION_ROOT}.eam-integration`,
    component: EamIntegration,
  },
  {
    key: SETTINGS_TAB_KEYS.vpamIntegration,
    titleKey: `${TRANSLATION_ROOT}.vpam-integration`,
    component: VpamIntegration,
  },
  {
    key: SETTINGS_TAB_KEYS.aipIntegration,
    titleKey: `${TRANSLATION_ROOT}.aip-integration`,
    component: AipIntegration,
  },
  {
    key: SETTINGS_TAB_KEYS.security,
    titleKey: `${TRANSLATION_ROOT}.application-access`,
    component: Security,
  },
  {
    key: SETTINGS_TAB_KEYS.passwordPolicy,
    titleKey: `${TRANSLATION_ROOT}.password-policy`,
    descriptionKey: 'portal.password-policy.description',
    component: PasswordPolicy,
  },
  {
    key: SETTINGS_TAB_KEYS.customize,
    titleKey: `${TRANSLATION_ROOT}.customize`,
    component: Appearance,
  },
  {
    key: SETTINGS_TAB_KEYS.loginActivityReport,
    titleKey: `${TRANSLATION_ROOT}.login-activity-report`,
    component: LoginActivityReport,
  },
  {
    key: SETTINGS_TAB_KEYS.epcsActivityReport,
    titleKey: `${TRANSLATION_ROOT}.epcs-activity-report`,
    component: EpcsActivityReport,
  },
  {
    key: SETTINGS_TAB_KEYS.advancedSettings,
    titleKey: `${TRANSLATION_ROOT}.advanced-settings`,
    component: AdvancedSettings,
  },
];
